import { IDS } from '../add-document-action-id.constants';
import { IDS as MASTER_DOC_LIST_IDS } from '../../master-doc-list/master-doc-list-action-id.constants';
import { IDS as SECTION_IDS } from '../../requirements-assessment/requirements-assessment-action-id.constants';
import * as Actions from '../add-document.actions';
import get from 'lodash/get';
import pick from 'lodash/pick';
import I18N from "../../../../common/utils/util.i18n";
import {GRID_FILTER} from "../../../../common/grid/grid.constants";

class AccAddFromExistingController {
    constructor($ngRedux,
                $state,
                $stateParams,
                $filter,
                $http,
                $mdDialog,
                FileUploader,
                Notifier,
                FileActions,
                EmployeeService,
                DocumentManager) {
        this.$ngRedux = $ngRedux;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$filter = $filter;
        this.$http = $http;
        this.$mdDialog = $mdDialog;
        this.FileUploader = FileUploader;
        this.Notifier = Notifier;
        this.FileActions = FileActions;
        this.EmployeeService = EmployeeService;
        this.DocumentManager = DocumentManager;
        this.identifier = IDS.accAddDocument;
    }

    $onInit() {
        this.isPublic = this.$state.$current.name.split('.')[0] === 'public';
        this.schemeCode = this.$stateParams.itemCode;
        this.showSection = !!this.$stateParams.requirement;

        this.$ngRedux.dispatch({ type: 'INPUT_TEXT_AREA_CHANGE', id: IDS.accAddDocument, path: 'documentName',          input: '' });
        this.$ngRedux.dispatch({ type: 'INPUT_TEXT_AREA_CHANGE', id: IDS.accAddDocument, path: 'documentDescription',   input: '' });

        this.unsubscribe = this.$ngRedux.connect(state => {
            const accAddDocument    = state.accreditation.accAddDocument;
            const assessmentItem            = accAddDocument?.assessmentItem;
            const evidenceTaskStatusCode    = assessmentItem?.evidenceTask?.status_code;
            const accDashboardLocationYear = state.accreditation.accDashboardLocationYear;
            return {
                ...pick(accAddDocument,[
                'siteLocationName',
                'siteLocationUuid',
                'sectionId',
                'sectionName',
                'sectionDescription',
                'sectionStatusName',
                'sectionStatusCode',
                'documentTypes',
                'documentType',
                'documentName',
                'documentDescription',
                ]),
                uploadButtonDisabled:   !assessmentItem || assessmentItem.evidenceTask && evidenceTaskStatusCode !== 'pen',
                docGeneratingEnabled:   get(accAddDocument, 'assessmentItem.generator_type'),
                evidenceTask:           assessmentItem?.evidenceTask,
                evidenceTaskStatus:     evidenceTaskStatusCode && I18N.translate(`ACCREDITATION.EVIDENCE.STATUS.${evidenceTaskStatusCode.toUpperCase()}`),
                isUserEmployee:         !state.app.user.typeCode,
                sampleDocPath:          assessmentItem?.sample_doc_path,
                sampleDocFilename:      assessmentItem?.sampleDocFilename,
                fiscalYear:             accDashboardLocationYear.year,
            }
        }, {
            ...Actions,
            // ...EvidenceActions,
            ...this.FileActions,
        })(this);

        const { section, slo } = this.$stateParams;
        if(section && section !== this.sectionId) {
            this.getFrameworkRequirementDetails(section);
        }
        this.fetchSiteLocationDetails(slo).then(() => {
            this.$ngRedux.dispatch({
                type: GRID_FILTER,
                id: this.identifier,
                path: IDS.addFromExistingGrid,
                filter: {
                    siteLocationUuid: slo,
                    sectionId: section,
                }
            });
        });
    }

    onAddButton({item}) {
        // this.assignVersionedDocToSection(item.vdo_uuid, this.sectionId, this.siteLocationUuid).then(() => {
        //     this.$ngRedux.dispatch({
        //         type: 'GRID_RELOAD',
        //         id: this.identifier,
        //         path: IDS.addFromExistingGrid,
        //     });
        // });
    }

    onDownloadButton({item}) {
        this.DocumentManager.downloadFile(item.doc_url);
    }

    onButtonBack() {
        if(this.sectionName)
            this.goToSection();
        else
            this.goToMasterDocList();
    }

    goToSection() {
        this.$state.go(SECTION_IDS.app_accreditation_scheme_requirements_assessment_evidence_groups, {
            itemCode:   this.schemeCode,
            section:   this.sectionId,
            year:       this.fiscalYear,
            slo:        this.siteLocationUuid,
        });
    }

    goToMasterDocList() {
        this.$state.go(MASTER_DOC_LIST_IDS.app_accreditation_scheme_master_doc_list, {
            itemCode: this.schemeCode,
        });
    }

    downloadSampleDoc() {
        let path = this.sampleDocPath;
        if(path) {
            if(path.includes('/') === false) // template with default path
                path = `/acc_doc/reference/${path}`;
            this.download(`storage${path}`);
        }
    };

    $onDestroy() {
        this.unsubscribe();
    }
}

AccAddFromExistingController.$inject = [
    '$ngRedux',
    '$state',
    '$stateParams',
    '$filter',
    '$http',
    '$mdDialog',
    'FileUploader',
    'Notifier',
    'FileActions',
    'EmployeeService',
    'DocumentManager']

export const accAddFromExisting = {
    controller: AccAddFromExistingController,
    template: require('./from-existing.html')
}
